import i18n from "i18next";
import i18nLangDet from "i18next-browser-languagedetector";
import resources from '../locales';
import {DateTimePickerEditable} from 'libs/jquery-editable/modules/datepicker.editable'
import $i18n from "jquery-i18next";

const $ = require('jquery');
const _ = require('underscore');
const Handlebars = require('handlebars');
require('./handlebars-helpers');
require('libs/bootstrap-3.3.2-dist/js/bootstrap.min');
require('libs/jquery-metroUi/js/metro-notify');
require('jquery-datetimepicker');
require("jquery-datetimepicker/jquery.datetimepicker.css");

const moment = require('moment');
const libphonenumber = require("libphonenumber");
var callingcode = libphonenumber.PhoneNumberUtil.getInstance();
var hasExpired = false;
var paypalConfig = function () {
    return {};
};

var exampleNumber = '999999999';

$(function () {
    $i18n.init(i18n, $, {
        tName: 't', // --> appends $.t = i18next.t
        i18nName: 'i18n', // --> appends $.i18n = i18next
        handleName: 'i18n', // --> appends $(selector).localize(opts);
        selectorAttr: 'data-i18n', // selector for translating elements
        targetAttr: 'i18n-target', // data-() attribute to grab target element to translate (if diffrent then itself)
        optionsAttr: 'i18n-options', // data-() attribute that contains options, will load/set if useOptionsAttr = true
        useOptionsAttr: false, // see optionsAttr
        parseDefaultValueFromContent: true // parses default values from content ele.val or ele.text
    });

    i18n.use(i18nLangDet)
        .init({
            fallbackLng: 'el',
            initImmediate: false,
            resources,
            whitelist: ['en', 'el'],
            detection: {
                order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag']
            }
        }, main.bind(this));
});

async function main(t) {

    const $thank1 = $('#thank-you-1');
    const $thank2 = $('#thank-you-2');
    const $thank3 = $('#thank-you-3');

    this.isComponent = (type) => ["SurveyImage", "SurveyFormattedText", "SurveySocialShare", "SurveySocialFollow"].indexOf(type) > -1;
    const isNotColor = str => !/#[0-9a-fA-F]{3,6}/.test(str);
    const isCustomImage = str => /^[0-9a-fA-F]{24}$/.test(str);

    let self = this;
    const payPalButtonTemplate = require('./templates/paypal.button.template.htm');
    const templates = {
        SurveyStarRating: Handlebars.compile(require('./templates/survey.star.rating.template.htm')),
        SurveyFreeText: Handlebars.compile(require('../../common/templates/survey.free.text.template.htm')),
        SurveyMultipleChoice: Handlebars.compile(require('./templates/survey.multiple.choice.template.htm')),
        SurveyDate: Handlebars.compile(require('../../common/templates/survey.date.template.htm')),
        SurveyImage: Handlebars.compile(require('./templates/survey.image.template.htm')),
        SurveyFormattedText: Handlebars.compile(require('../../common/templates/survey.formatted.text.template.htm')),
        SurveySocialFollow: Handlebars.compile(require('./templates/survey.social.follow.template.htm')),
        SurveySocialShare: Handlebars.compile(require('./templates/survey.social.share.template.htm')),
        PayPalButton: Handlebars.compile(payPalButtonTemplate),
        CustomFieldComponent: Handlebars.compile(require('../../common/templates/custom.field.template.htm')),
        CustomFieldMultipleChoiceComponent: Handlebars.compile(require('../../common/templates/custom.field.multiplechoice.template.htm'))
    };

    let match = window.location.href.match(/#(\d*)$/);
    if (!match && window.location.hash.indexOf("paypal") > -1 && window.history) {
        window.history.back();
        window.setTimeout(function () {
            window.location.reload();
        }, 0);
    }
    self.campaignId = match ? match[1] : null;

    $('html').attr('lang', i18n.options.lng);
    if (!self.campaignId) {
        $("#code").hide();
        console.log("Code missing");
        return;
    }
    try {
        const alldata = await $.ajax({
            type: "GET",
            url: `/CampaignCloud/emailoptin/${self.campaignId}`,
            dataType: "json"
        });

        $('[data-i18n]').i18n();

        var type = alldata[2].type;
        const $submitbutton = $('.submitbutton');
        if (type === "PAY_PAL_PAYMENT") {
            $submitbutton.html(i18n.t("getitnow"));
        }
        hasExpired = alldata[1].hasExpired === true;
        var data = alldata[0];
        let movedPercentage = data.backgroundImagePosition ? data.backgroundImagePosition : 0;
        if (alldata[2].countryPrefix) {
            callingcode.defaultCountryCode = alldata[2].countryPrefix;
            var exampleNumberWrapped = callingcode.getExampleNumberForType(callingcode.defaultCountryCode, 1);
            exampleNumber = callingcode.format(exampleNumberWrapped, libphonenumber.PhoneNumberFormat.E164);
        }

        const $expirationDate = $("#expirationDate");
        if (alldata[2].endDate) {
            var formattedDate = Handlebars.helpers.timestamp(new Date(alldata[2].endDate), "L HH:mm");
            $expirationDate.text(i18n.t("expires") + formattedDate);
        } else {
            $expirationDate.text(i18n.t("expires") + i18n.t("never"));
        }
        $expirationDate.show();

        if (hasExpired || (!alldata[2].areProductsAvailable && alldata[2].type === "PAY_PAL_PAYMENT")) {
            $submitbutton.prop("disabled", true);
            $submitbutton.off("click");

            const $expiredPageTitle = $("#expiredPageTitle");
            const $expiredPageText = $("#expiredPageText");
            const $expiredPageFooter = $("#expiredPageFooter");
            //TODO change if weed to use the paypal optin service to work the outer page after expiration
            $expiredPageTitle.text(parseChangeLineCharacters(alldata[1].endPageTitle));
            $expiredPageText.text(parseChangeLineCharacters(alldata[1].endPageText));
            $expiredPageFooter.text(parseChangeLineCharacters(alldata[1].endPageFooter));
            $("#expired").show();
        }
        if (isCustomImage(data.backgroundColor)) {
            const $headerImage = $("#headerImage");
            $headerImage.css("background-image", `url(/CampaignCloud/emailoptin/${self.campaignId}/getBgImage)`);
            $headerImage.css("background-position", `0px ${movedPercentage * 100}%`);
        } else {
            $('#surveycontainerB').addClass(data.backgroundColor);
        }
        if (isNotColor(data.fontColor)) {
            $('body').addClass(data.fontColor);
        } else {
            $('body').css("background-color", data.fontColor);
        }

        if (["QUIZ_OPTIN", "INSTANT_WIN", "PAY_PAL_PAYMENT"].includes(alldata[2].type)) {
            const documentTitle = alldata[2].type === "PAY_PAL_PAYMENT"
                ? "optinTitle"
                : alldata[2].isSweepstakes
                    ? i18n.t("sweepstakesText")
                    : i18n.t("instantWinText");

            document.title = i18n.t(documentTitle, {
                campaignId: self.campaignId
            });

            const $rulesFooterNote = $("#rulesFooterNote");
            $rulesFooterNote.html(alldata[2].footNote);
            $rulesFooterNote.show();
            $("#rules").html(parseChangeLineCharacters(alldata[2].rules));

            $("#closeRulesPopup").off().on('click', function () {
                $("#instantWinParticipationRulesPopup").hide();
            });
            $("#openRulesPopup").off().on('click', function () {
                $("#instantWinParticipationRulesPopup").show();
            });
        } else {
            $thank1.text(parseChangeLineCharacters(data.endTitle));
            $thank2.text(parseChangeLineCharacters(data.endText));
            $thank3.text(parseChangeLineCharacters(data.endFooter));
            document.title = i18n.t("optinTitle", {
                campaignId: self.campaignId
            });
        }

        var components = data.components;
        var questions = [];
        var qid = 0;
        components.forEach(function (val, i) {
            if (val.kind && val.kind === "mobile") {
                //add user default prefix on mobile textarea
                val.countryPrefix = alldata[2].countryPrefix;
            } else if (val.type && val.type === "PayPalButton") {
                val["notify_url"] = `${alldata[2].payPalPaymentServicesUrls && alldata[2].payPalPaymentServicesUrls.notify_url ? alldata[2].payPalPaymentServicesUrls.notify_url : ""}`;
                val["actionUrl"] = `${alldata[2].payPalPaymentServicesUrls && alldata[2].payPalPaymentServicesUrls.actionUrl ? alldata[2].payPalPaymentServicesUrls.actionUrl : ""}`;
                paypalConfig = function () {
                    return val;
                };
            }
            if (!self.isComponent(val.type)) {
                questions.push(val);
                qid++;
            }
            var markuptext = templates[val.type]({
                i: i,
                q: val,
                ans: null,
                campaignId: self.campaignId
            });
            //}
            var markup = $(markuptext);
            //if(val.type == "SurveyStarRating") {
            //$(markup).find('.star-rating').rating({language: '<LANG>', min:0, max:val.size, step:1, size:'lg'});
            //}
            $('#components').append(markup);
        });
        //Tell Twitter and Google to render their buttons if they exist
        renderSocialWidgets();

        // Adding Events.

        $('.email').on('input', _.debounce(function (event) {
            var value = event.currentTarget.value;
            checkEmail(value);
        }, 800));
        $('.mobile').on('input', _.debounce(function (event) {
            var value = event.currentTarget.value;
            checkMobile(event, value);
        }, 200));
        $('.decimal').on('input', _.debounce(function (event) {
            var value = event.currentTarget.value;
            checkNotANumber(event.currentTarget, value);
        }, 200));
        $('.text').on('input', _.debounce(function (event) {
            var value = event.currentTarget.value;
            checkInputLength(event.currentTarget, value);
        }, 200));
        $('.surveymultiplechoicelistcontainer').on('input', function (event) {
            const $select = $(event.currentTarget);
            $select.children('input').prop("checked", true);
        });
        $('.surveymultiplechoicelistselect').on('change', function (event) {
            const $select = $(event.currentTarget);
            $select.prop("checked", true);
        });
        var maxDateForPicker = new Date();
        maxDateForPicker = new Date(maxDateForPicker.getFullYear() - 1, maxDateForPicker.getMonth(), maxDateForPicker.getDate());
        const $date = $(".surveytextarea.date");

        $date.datetimepicker({
            onShow: function (current_time, input, inst) {

                DateTimePickerEditable.customButton(inst.currentTarget, $date, {
                    customButton: [{
                        classes: "clear dateButton button bg-cyan fg-white bg-hover-orange border small",
                        id: "clearButton1",
                        label: "Clear",
                        attrType: "date"
                    }, {
                        classes: "dataNullifyButton eventDateButton button bg-cyan fg-white bg-hover-orange border small",
                        id: "closeButton",
                        label: "Close"
                    }],
                    onblur: 'ignore'
                });

                var comp_id = `${input[0].id}`;
                $(window).bind("datetimepicker:clearDateButtonClicked", {c_id: comp_id}, function (ev, attrType, objectId, picker) {
                    if (attrType === 'date') {
                        $(`#${ev.data.c_id}`).datetimepicker('reset');
                    }
                });
            },
            format: i18n.t("$dateformat"),
            closeOnDateSelect: true,
            scrollInput: false,
            todayButton: false,
            timepicker: false,
            yearStart: 1900,
            yearEnd: new Date().getFullYear() - 1,
            setDate: new Date("23/03/2016"),
            minDate: new Date("1/1/1900"), /*lower boundary*/
            maxDate: maxDateForPicker /*upper boundary= today*/
        }).focus(function () {
            $('.surveytextarea.date').datetimepicker('setDate', maxDateForPicker);
        });



        const $datetime = $(".surveytextarea.datetime");
        $datetime.datetimepicker({
            onShow: function (current_time, input, inst) {

                DateTimePickerEditable.customButton(inst.currentTarget, $datetime, {
                    customButton: [{
                        classes: "clear dateButton button bg-cyan fg-white bg-hover-orange border small",
                        id: "clearButton2",
                        label: "Clear",
                        attrType: "datetime"
                    }, {
                        classes: "dataNullifyButton eventDateButton button bg-cyan fg-white bg-hover-orange border small",
                        id: "closeButton",
                        label: "Close"
                    }],
                    onblur: 'ignore'
                });

                var comp_id = `${input[0].id}`;
                $(window).bind("datetimepicker:clearDateButtonClicked", {c_id: comp_id}, function (ev, attrType, objectId, picker) {
                    if (attrType === 'datetime') {
                        $(`#${ev.data.c_id}`).datetimepicker('reset');
                    }
                });
            },
            format: i18n.t("$datetimeformat"),
            closeOnDateSelect: true,
            scrollInput: false,
            todayButton: true,
            yearStart: 1900,
            setDate: new Date("23/03/2016"),
            minDate: new Date("1/1/1900"), /*lower boundary*/
        }).focus(function () {
            $('.surveytextarea.datetime').datetimepicker('setDate', new Date());
        });

        const policyLabel = $(`<text>${i18n.t('privacypolicy')}</text>`);
        policyLabel.find('a').attr('href', alldata[2].privacyPolicyURL);
        $('#privacy-policy-text').html(policyLabel.html());

        $submitbutton.click(handleSubmit.bind(this, components));
    } catch (e) {
        $("#failure").show();
        console.error(e);
    }
}

async function handleSubmit(components, event) {

    const $thank1 = $('#thank-you-1');
    const $thank2 = $('#thank-you-2');
    const $thank3 = $('#thank-you-3');

    let self = this;

    const $submitbutton = $(event.currentTarget);
    let valid = $("#privacy-policy").find("input").is(":checked");
    let bday;
    components.forEach(function (val, i) {
        const input = $(`#q${i}`);
        const ans = $(input).val();
        if (val.type === "SurveyFreeText" || val.type === "CustomFieldComponent") {
            if (ans === "") {
                $(input).fadeIn(100).fadeOut(100).fadeIn(100);
                valid = valid && !val.required;
            }
        } else if (val.type === "SurveyDate") {
            if (ans)
                bday = `date:${moment(ans, i18n.t("momentDateTimeFormat")).format('YYYY-MM-DD')}`;
            else
                valid = valid && !val.required;
        } else if (val.type === "CustomFieldMultipleChoiceComponent") {
             if ($(`.choice${i}:checked`).length === 0 && $(`.single-select-${i}`).find(":checked").length === 0 ) {
                $(input).fadeIn(100).fadeOut(100).fadeIn(100);
                valid = valid && !val.required;
            }
            else if ($(`.single-select-${i}`).find(":checked").val() === "") {
                $(input).fadeIn(100).fadeOut(100).fadeIn(100);
                valid = valid && !val.required;
            }
        }
    });

    if (!valid) {
        alert(i18n.t("requiredfields"));
        return;
    }
    var answers = [];
    components.forEach(function (val, i) {
        var input = $(`#q${i}`);
        if (val.type === "SurveyFreeText") {
            if (val.kind && val.kind === "address") {
                //if address component already exists, append `input.val` to the existing one, using a `|` as separator
                var tempIndex = -1;
                var currentAddressAnswer = $.grep(answers, function (ans, indx) {
                    if (ans.kind === "address") {
                        tempIndex = indx;
                    }
                    return ans.kind === "address";
                });
                if (tempIndex > -1) {
                    answers[tempIndex].freetext += `,${$(input).val()}`;
                } else {
                    //else just push the answer
                    answers.push({
                        freetext: $(input).val(),
                        kind: val.kind
                    });
                }
            } else {
                //else just push the answer
                answers.push({
                    freetext: $(input).val(),
                    kind: val.kind
                });
            }
        } else if (val.type === "SurveyDate") {
            answers.push({
                date: bday,
                kind: val.kind
            });
        } else if (val.type === "CustomFieldComponent") {
            var text;
            if ($(input).hasClass("datetime")) {
                const date = moment($(input).val(), i18n.t("momentDateTimeFormat"));
                text = date.isValid() ? date.valueOf().toString() : "";
            } else {
                text = $(input).val();
            }
            answers.push({
                freetext: text,
                kind: val.kind
            });
        }  else if (val.type === "CustomFieldMultipleChoiceComponent") {

            let value;
            const select = $(`.single-select-${i}`);
            if (select.length) {
                const $checkedSelect = select.find(":checked");
                if ($checkedSelect.val() !== "") {
                    value = $checkedSelect.val();
                } else if (val.required) {
                    input.fadeIn(100).fadeOut(100).fadeIn(100);
                    valid = false;
                }
            } else {
                const $checkedChoice = $(`.choice${i}:checked`);
                value = $checkedChoice.val();
                const len = $checkedChoice.length;

                if (val.required && len === 0) {
                    input.fadeIn(100).fadeOut(100).fadeIn(100);
                    valid = false;
                }
            }
            answers.push({
                freetext: value,
                kind: val.kind
            });
        }
    });
    answers = {
        answers: answers
    };
    $submitbutton.prop("disabled", true);
    const $spinner = $('#spinner');
    $spinner.show();
    try {
        const data = await $.ajax({
            type: "POST",
            url: `/CampaignCloud/emailoptin/${self.campaignId}`,
            data: {
                answers: JSON.stringify(answers)
            },
            dataType: "json",
        });
        $spinner.hide();
        var $alreadyOptedInMask = $("#alreadyOptedInMask");
        if (data.paymentStatus === "NOT_IN_STOCK") {
            $alreadyOptedInMask.find("#outOfStockPageTitle").text(i18n.t("outOfStockTitleText"));
            $alreadyOptedInMask.find("#outOfStockPageText").text(i18n.t("outOfStockPageText"));
            $alreadyOptedInMask.show();
        } else if (data.paymentStatus === "TRANSACTION_IN_PROGRESS") {
            $alreadyOptedInMask.find("h1").text(i18n.t("transactionInProgress"));
            $alreadyOptedInMask.show();
        } else if (data.paymentStatus === "FAILURE") {
            $alreadyOptedInMask.find("h1").text(i18n.t("somethingWrong"));
            $alreadyOptedInMask.show();
        } else if (data.hasExpired) {
            $submitbutton.prop("disabled", true);
            $submitbutton.off("click");
            $("#expiredPageTitle").text(i18n.t("expiredPageTitle"));
            $("#expiredPageText").text(i18n.t("expiredPageText"));
            $("#expiredPageFooter").text(i18n.t("expiredPageFooter"));
            $("#expired").show();
        } else {
            if (data.status === "ALREADY_PARTICIPATED") { //only on Instant Win
                $alreadyOptedInMask.find("h1").text(i18n.t("alreadyParticipated"));
                $alreadyOptedInMask.show();
                $submitbutton.prop("disabled", false);
            } else if (data.status === "ALREADY_OPTED_IN") { //Email Optin. Should not appear on Instant Wins
                if (data.type !== "PAY_PAL_PAYMENT") { //non-payment service
                    $alreadyOptedInMask.find("h1").text(i18n.t("alreadyOptedIn"));
                    $alreadyOptedInMask.show();
                    $submitbutton.prop("disabled", false);
                }
            } else if (data.status === "VALID_EMAIL_OR_MOBILE_MISSING") {
                $alreadyOptedInMask.find("h1").text(i18n.t("validEmailOrMobileMissing"));
                $alreadyOptedInMask.show();
                $submitbutton.prop("disabled", false);
            } else if (data.status === "INVALID_EMAIL_DOMAIN") {
                $('#error-email').text(i18n.t("invalidEmailDomain")).show();
                $submitbutton.prop("disabled", false);
                return;
            } else if (data.status === "MALFORMED_EMAIL") {
                $('#error-email').text(i18n.t("malformedEmail")).show();
                $submitbutton.prop("disabled", false);
                return;
            } else {
                components.forEach(function (val, i) {
                    var input = $(`#q${i}`);
                    if (val.type === "SurveyFreeText") {
                        $(input).prop("disabled", true);
                    }
                });
            }

            if (data.type === "PAY_PAL_PAYMENT") { //payment service
                var conf = paypalConfig();
                conf.subscriptionId = data.subscriptionId;
                conf.optinId = data.optinId;
                conf.quantity = 1;
                conf.amount = conf.quantity * conf.price;
                paypalConfig = function () {
                    return conf;
                };

                setUpPayPalButton(conf);
                $(".mask2:visible").append($("#paypal-button"));
                $thank1.text(i18n.t("oneMoreStep"));
                $thank2.text(i18n.t("selectPaymentMethod"));
                $thank3.html('<div><br/><img id="paypalButtonImage" src="https://www.paypalobjects.com/webstatic/en_US/i/btn/png/gold-pill-paypal-60px.png" alt="PayPal Checkout" style="cursor:pointer"/></div>');

                $("#paypalButtonImage").off().on("click", function () {
                    $("#paypal-button").find("button").trigger("click");
                    window.postPageTexts = {
                        title: parseChangeLineCharacters(data.texts.endPageTitle),
                        text: parseChangeLineCharacters(data.texts.endPageText),
                        footer: parseChangeLineCharacters(data.texts.endPageFooter)
                    };
                });
            } else { //non-payment service
                $thank1.text(parseChangeLineCharacters(data.texts.endPageTitle));
                $thank2.text(parseChangeLineCharacters(data.texts.endPageText));
                $thank3.text(parseChangeLineCharacters(data.texts.endPageFooter));
            }
            $thank1.show();
            $thank2.show();
            $thank3.show();
            $('#thank-you-all').show().ready(function () {
                setInterval(function () {
                    cache_clear()
                }, 5000);
            });


        }
    } catch (e) {
        console.error(e);
        $spinner.hide();
        $submitbutton.prop("disabled", false);
    }
}

function cache_clear() {
    window.location.reload(true);
    // window.location.reload(); use this if you do not remove cache
}

function renderSocialWidgets() {

    var twSelector = ".twitter-share-button, .twitter-follow-button";
    var gpSelector = ".gplus-share-button, .g-follow";

    $(twSelector).each(function (idx, el) {
        twttr.widgets.load(el);
    });
    $(gpSelector).each(function (idx, el) {
        gapi[$(el).hasClass("g-follow") ? "follow" : "plus"].go(el.tagName);
    });
}

function checkEmail(value) {
    value = value.trim();
    var re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
    var isEmailValid = value != null && value.length > 0 && re.test(value);
    if (isEmailValid) {
        onValid();
    } else {
        onInvalid();
    }
}

function checkNotANumber(e, input) {
    input = input.trim();
    var re = /^-?[0-9]+([.][0-9]+)?$/g;
    if (input !== '' && !re.test(input)) {
        $(e).parent().find('#error-decimal').show();
        $('.submitbutton').prop("disabled", true);
    } else {
        $(e).parent().find('#error-decimal').hide();
        $('.submitbutton').prop("disabled", false);
    }
}

function checkMobile(event, value) {
    value = value.trim();
    if (value.indexOf("00") === 0) {
        value = `+${value.substring(2)}`;
    }

    const $msisdn = $("#msisdn-flag");
    const $email = $('#email-msisdn');
    if (value.length > 0) {
        try {
            const parsedPhoneNum = callingcode.parseAndKeepRawInput(value, callingcode.defaultCountryCode);
            const c = callingcode.getRegionCodeForNumber(parsedPhoneNum);
            const numberType = callingcode.getNumberType(parsedPhoneNum);

            if (numberType === 1 || numberType === 2) {
                $msisdn.removeClass();
                $msisdn.addClass("flag-icon");
                $msisdn.addClass(`flag-icon-${c.toLowerCase()}`);
                value = callingcode.format(parsedPhoneNum, libphonenumber.PhoneNumberFormat.E164);
                $msisdn.show();
                $(event.currentTarget).val(value);
                onMobileValid();
            } else {
                throw new Error("Unacceptable number type");
            }
        } catch (e) {
            console.info(`Not a valid cellphone: ${value} ${e}`);
            $email.removeClass('required-input');
            $email.removeClass('valid-input');
            $email.addClass('invalid-input');
            $email.addClass('confirm-failure-input-borders');
            $('#error-mobile').text(i18n.t("msisdnerror", {examplenumber: exampleNumber}));
            $msisdn.hide();
            onMobileInvalid();
        }
    } else {
        $msisdn.removeClass();
    }
}

// Valid mobile function
function onMobileValid() {
    if (!hasExpired) {
        $('.submitbutton').prop("disabled", false);
    }
    $('#error-mobile').hide();
}

// Invalid mobile function
function onMobileInvalid() {
    $('.submitbutton').prop("disabled", true);
    $('#error-mobile').text(i18n.t("msisdnerror", {examplenumber: exampleNumber})).show();
}

// Valid email function
function onValid() {
    if (!hasExpired) {
        $('.submitbutton').prop("disabled", false);
    }
    $('#error-email').hide();
}

// Invalid email function
function onInvalid() {
    $('.submitbutton').prop("disabled", true);
    $('#error-email').text(i18n.t("malformedEmail")).show();
}

function checkInputLength(e, input) {
    if (!$(e).data("maxlength")) return;
    var maxLength = parseInt($(e).data("maxlength"));
    if (input.length > maxLength) {
        $(e).parent().find('#error-varchar').show();
        $('.submitbutton').prop("disabled", true);
    } else {
        $(e).parent().find('#error-varchar').hide();
        $('.submitbutton').prop("disabled", false);
    }
}

function parseChangeLineCharacters(rawText) {
    return rawText.replace(/\\n/g, "\n");
}

function urlParams(obj) {
    var str = "";
    for (var key in obj) {
        if (str !== "") {
            str += "&";
        }
        if (obj.hasOwnProperty(key))
            str += `${key}=${encodeURIComponent(obj[key])}`;
    }
    return str;
}

async function setUpPayPalButton(payment) {

    const $thank1 = $('#thank-you-1');
    const $thank2 = $('#thank-you-2');
    const $thank3 = $('#thank-you-3');
    const $spinner = $("#spinner");

    var paypalBase = `${location.origin}/CampaignCloud/oauthClient/paypal/`;
    var CANCEL_PAYMENT_URL = `${paypalBase}cancelPayment`;


    window.onbeforeunload = function () {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                console.log(xhr.responseText);
            }
        };
        var pc = paypalConfig();
        var params = {
            subscriptionId: pc.subscriptionId,
            optinId: pc.optinId
        };
        var getParams = "?" + urlParams(params);
        xhr.open('GET', CANCEL_PAYMENT_URL + getParams, false);
        xhr.send();
    };

    window.addEventListener("hashchange", function (event) {
        var newHash = location.hash;
        var routes = newHash.split('/');
        if (routes[0] === "#paypal") {
            var url = paypalBase + routes[1];
            var getReq;
            var text;
            var multipleTexts = false;
            $spinner.addClass("overlay").show();
            if (routes[1].indexOf("cancelPayment") > -1) {
                var pc = paypalConfig();
                getReq = $.get(url, {
                    subscriptionId: pc.subscriptionId,
                    optinId: pc.optinId
                });
                text = i18n.t("paymentcancel");
            } else if (routes[1].indexOf("executePayment") > -1) {
                getReq = $.get(url);
                multipleTexts = true;

            } else {
                var msg = routes[2];
                text = i18n.t(`payment${msg.toLowerCase()}`);
                getReq = $.Deferred().resolve(text);
            }
            getReq.then(function (data) {
                if (!multipleTexts) {
                    $(".mask2:visible").html(`<h1>${text}</h1>`);
                } else {
                    $thank1.empty();
                    $thank1.text(window.postPageTexts.title);
                    $thank2.empty();
                    $thank2.text(window.postPageTexts.text);
                    $thank3.empty();
                    $thank3.text(window.postPageTexts.footer);
                }

                $("#spinner").removeClass("overlay").hide();
            });
        }
    }, false);
    $spinner.addClass("overlay").show();
    try {
        const resp1 = await $.get('/CampaignCloud/oauthClient/paypal/environment');
        const resp2 = await $.get('/CampaignCloud/oauthClient/paypal/merchantId');
        renderPaypalButton(resp1, resp2, payment, paypalBase);
        $spinner.removeClass("overlay").hide();
    } catch (e) {
        console.error(e);
    }
}

function renderPaypalButton(environment, merchantId, payment, paypalBase) {
    var paypal = window.paypal;
    var CREATE_PAYMENT_URL = `${paypalBase}createPayment`;
    var CANCEL_PAYMENT_URL = `${paypalBase}cancelPayment`;
    // var EXECUTE_PAYMENT_URL = paypalBase + 'executePayment';
    paypal.checkout.setup(merchantId, {

        environment: environment,
        container: 'paypal-button',

        click: async function () {
            paypal.checkout.initXO();
            const $spinner = $("#spinner");
            $spinner.addClass("overlay").show();
            try {
                const data = await $.post(CREATE_PAYMENT_URL, {
                    paymentType: "Sale",
                    itemAmount: payment.price,
                    itemQuantity: payment.quantity,
                    itemName: payment.itemName,
                    optinId: payment.optinId,
                    subscriptionId: payment.subscriptionId,

                });
                if (typeof data === "string") {
                    location.hash = `#paypal/failure/${data}`;
                    paypal.checkout.closeFlow();
                } else
                    paypal.checkout.startFlow(data.token);
                $spinner.removeClass("overlay").hide();

            } catch (e) {
                console.error(e);
                $.post(CANCEL_PAYMENT_URL, payment.custom).always(function (data) {
                    $spinner.removeClass("overlay").hide();
                });
                paypal.checkout.closeFlow();
            }
        }
    });
}

// Warning
$.Notify.warn = function (message, title) {
    return $.Notify({
        content: message,
        style: {
            color: '#8a6d3b',
            background: '#fcf8e3'
        },
        caption: title
    });
};